import axios from "./request";
import qs from "qs";
// 筛选项
export const getcaptcha = `${axios.defaults.baseURL}/resource/captcha`;
export const uploadAction = `${axios.defaults.baseURL}/v1/resource/upload`;

export const getProjectInit = params => {
    return axios
        .post(`/v1/company/project/init`, qs.stringify(params))
        .then(res => res.data);
};

export const getDistrict = params => {
    return axios
        .post(`/v1/resource/district`, qs.stringify(params))
        .then(res => res.data);
};

export const projectSave = params => {
    return axios
        .post(`/v1/company/project/save`, qs.stringify(params))
        .then(res => res.data);
};

